/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { InfoIcon } from '@chakra-ui/icons'
import { toCamelCase } from '../../../../utils/schemaUtils'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  SimpleGrid,
  Tag,
  Text,
  Tooltip
} from '@chakra-ui/react'
import dayjs from 'dayjs'

export function generateVisitFields(
  field: any,
  values: any,
  subCategoryLevel = 0
) {
  if (values.isFollowUp) {
    if (field.type === 'subcategory' && !field.isFollowUp) {
      return field.fields?.map((subField: any) =>
        generateVisitFields(subField, values, subCategoryLevel + 1)
      )
    } else {
      if (values.isFollowUp && !field.isFollowUp) return null
      return (
        <Box key={field.id} mt={4}>
          <Flex alignItems="center" gap={1}>
            <Text fontWeight="bold">{field.displayName}</Text>
            {field.description && (
              <Tooltip label={field.description}>
                <InfoIcon boxSize={3} />
              </Tooltip>
            )}
          </Flex>
          <Text>
            {values[toCamelCase(field.displayName)]
              ? values[toCamelCase(field.displayName)]
              : '-'}
          </Text>
        </Box>
      )
    }
  }

  if (field.type === 'subcategory') {
    return (
      <Box gridColumn="1 / -1" key={field.id}>
        <Accordion allowMultiple allowToggle>
          <AccordionItem>
            <h2>
              <AccordionButton>
                <Box as="span" flex="1" textAlign="left">
                  {field.displayName}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              <SimpleGrid columns={2}>
                {field.fields?.map((subField: any) =>
                  generateVisitFields(subField, values, subCategoryLevel + 1)
                )}
              </SimpleGrid>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Box>
    )
  }
  if (field.type === 'memoryList') {
    return (
      <Box key={field.id} mt={4}>
        <Text fontWeight="bold">{field.displayName}</Text>
        {values[toCamelCase(field.displayName)]?.map((value: string) => (
          <Tag mr={2} key={value}>
            {value}
          </Tag>
        ))}
      </Box>
    )
  } else {
    if (field.type === 'date') {
      return (
        <Box key={field.id} mt={4}>
          <Flex alignItems="center" gap={1}>
            <Text fontWeight="bold">{field.displayName}</Text>
            {field.description && (
              <Tooltip label={field.description}>
                <InfoIcon boxSize={3} />
              </Tooltip>
            )}
          </Flex>
          <Text>
            {values[toCamelCase(field.displayName)]
              ? dayjs(values[toCamelCase(field.displayName)]).format(
                  'DD/MM/YYYY'
                )
              : '-'}
          </Text>
        </Box>
      )
    }
    return (
      <Box key={field.id} mt={4}>
        <Flex alignItems="center" gap={1}>
          <Text fontWeight="bold">{field.displayName}</Text>
          {field.description && (
            <Tooltip label={field.description}>
              <InfoIcon boxSize={3} />
            </Tooltip>
          )}
        </Flex>
        <Text>
          {values[toCamelCase(field.displayName)]
            ? `${values[toCamelCase(field.displayName)]} ${field.unit ?? ''}`
            : '-'}
        </Text>
      </Box>
    )
  }
}
